import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=65f9488e&scoped=true&"
import script from "./Counter.vue?vue&type=script&lang=js&"
export * from "./Counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f9488e",
  null
  
)

export default component.exports